<template>
  <section id="userIndex" v-if="mainSection">
    <v-row justify="space-between" align="center">
      <v-col cols="7" md="auto" class="flex-grow-1 d-flex align-center">
        <v-btn
          @click="backAction"
          rounded
          class="rounded-xl mr-3"
          small
          plain
          min-width="0"
          :dark="isDark"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h2
          :class="[
            isMobile ? 'h5' : 'h4',
            isMobile && isDark ? 'white--text' : 'primary--text'
          ]"
          style="word-break: normal"
        >
          {{ evaluationName }}
        </h2>
      </v-col>

      <v-col cols="auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              fab
              v-bind="attrs"
              v-on="on"
              color="info"
              @click="rangeDialogActive = true"
              :loading="isDownloadingReport"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar Reporte</span>
        </v-tooltip>
      </v-col>
      <v-col cols="5" md="auto" class="py-0" v-if="user !== 'agent'">
        <v-switch
          class="ml-auto"
          v-model="activeGraph"
          inset
          label="Ver gráficas"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row class="justify-between align-center">
      <v-col cols="12" md="auto" class="ml-auto">
        <v-text-field
          filled
          rounded
          dense
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card class="shadow-1 mt-5">
      <v-card flat>
        <!-- Tabla -->
        <v-container v-show="!activeGraph">
          <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>

          <v-row v-else dense justify="end">
            <v-col cols="12">
              <vuescroll
                :ops="{
                  bar: {
                    background: '#bacfcec0',
                    keepShow: true
                  }
                }"
              >
                <v-data-table
                  :headers="tableHeaders"
                  :items="data"
                  class="elevation-0"
                  :options.sync="tableOptions"
                  :server-items-length="totalItems"
                  :loading="isLoadingTable"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    <span class="d-inline pr-2">
                      {{ normalizeDate(item.date) }}
                    </span>
                  </template>
                  <template v-slot:[`item.test`]="{ item }">
                    <span class="d-inline pr-2">
                      {{ getAverage(item) }}
                    </span>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-hover v-slot:default="{ hover }">
                      <v-btn
                        :disabled="item.cantTest > 0 ? false : true"
                        text
                        icon
                        :color="hover ? 'accent' : 'blue-grey'"
                        @click.stop="goToReport(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </v-hover>
                  </template>
                </v-data-table>
              </vuescroll>
            </v-col>
            <!-- <v-col cols="auto">
                            <v-pagination
                                circle
                                color="primary"
                                v-model="page"
                                :length="pageCount"
                                @click="handlePageChange"
                            ></v-pagination>
                        </v-col> -->
          </v-row>
        </v-container>

        <!-- Gráficas -->
        <v-container v-if="activeGraph" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="5" v-if="render">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart5"
                    type="donut"
                    :options="optionsDonut"
                    :series="donutSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else-if="!render" cols="12" md="5">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col v-if="render" cols="12" md="6">
              <v-card outlined>
                <!-- <v-card-title
                  class="title text--primary"
                  style="word-break: normal; line-height: normal"
                >
                  Llamadas entrantes por extensión
                </v-card-title> -->
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar"
                    :series="barSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>

    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      :id="id"
      module="testReport"
      @dialog:change="eventdialog"
    ></RangeDateDialog>
  </section>
  <AgentDetail
    v-else
    :user="user"
    :idEvaluation="id"
    :itemToShow="itemToShow"
    @mainSection="goToMainSection()"
  />
</template>

<script>
import moment from "moment";
import vuescroll from "vuescroll";
import AgentDetail from "./AgentDetail";
import RangeDateDialog from "@/components/DatePickers/DateRangePicker";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: { vuescroll, AgentDetail, RangeDateDialog },
  props: {
    id: {
      type: String,
      default: null
    },
    user: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      rangeDialogActive: false,
      evaluationName: null,
      data: [],
      tableOptions: {},
      tableHeaders: [
        { text: "Nombre", value: "name", width: "20%" },
        { text: "Extensión", value: "extension", width: "10%" },
        {
          text: "# de pruebas",
          value: "cantTest",
          width: "20%"
        },
        {
          text: "Promedio total",
          value: "test",
          width: "25%"
        },
        {
          text: "Acciones",
          value: "action",
          width: "25%"
        }
      ],
      searchQuery: "",
      render: false,
      isLoading: true,
      isLoadingTable: false,
      isDownloadingReport: false,
      activeGraph: false,
      itemToShow: null,
      mainSection: true,
      page: 1,
      pageCount: null,
      totalItems: 0,
      reportApi: {
        default: `/quality/report/evaluation/detaill/`,
        agent: `/report/agent/evaluation_id_agent/`
      },
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              }
            }
          }
        ],
        width: "100%",
        legend: {
          position: "bottom"
        },
        dataLabels: { enabled: false },
        labels: []
      },
      optionsBar: {
        xaxis: {
          categories: []
        },
        fill: {
          colors: ["#6D71F9"]
        }
      }
    };
  },
  mounted() {
    this.getReports();
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
    donutSeries() {
      return this.data.map((el) => el.cantTest);
    },
    barSeries() {
      return [{ name: "Cantidad", data: this.donutSeries }];
    }
  },

  watch: {
    tableOptions: {
      handler() {
        this.getReports();
      },
      deep: true
    }
  },

  methods: {
    handlePageChange(value) {
      this.page = value;
      this.getReports();
    },
    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    
    getAverage(item) {
      if (!item || !item.test || !item.test[0]) return "0";

      const cantTest = Number(item.cantTest);
      const sumTest = Number(item.test[0].sumtest);

      if (cantTest > 0 && !isNaN(sumTest)) {
        return (sumTest / cantTest).toFixed(2);
      }

      return "0";
    },

    goToReport(item) {
      this.itemToShow = item;
      this.mainSection = false;
    },
    goToMainSection() {
      this.mainSection = true;
      this.itemToShow = null;
    },
    backAction() {
      return this.user === "default"
        ? this.$router.push(`/reporte-pruebas`)
        : this.$router.push(`/test-report`);
    },
    async getReports() {
      this.isLoadingTable = true;
      const page = this.tableOptions.page || 1;
      const itemPerPage = this.tableOptions.itemsPerPage || 10;
      try {
        const res = await PbxHttpClient.get(
          `${this.reportApi[this.user]}${this.id}`,
          {
            params: {
              page,
              approved_status: this.$route.params.status,
              itemPerPage
            }
          }
        );

        this.data = res.data.data;
        this.totalItems = res.data.total;
        this.evaluationName = res.data.data[0].test[0].evaluation.name;
        this.optionsDonut.labels = res.data.data.map((el) => el.name);
        this.optionsBar.xaxis.categories = res.data.data.map((el) => el.name);
        // console.log(res);
      } catch (error) {
        // console.error(error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
      this.render = true;
      this.isLoadingTable = false;
      this.isLoading = false;
    },
    async downloadReport() {
      this.isDownloadingReport = true;
      try {
        const res = await PbxHttpClient.get(
          `/quality/export/evaluation/detaill/${this.id}`,
          {
            responseType: "blob"
          }
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Reporte de ${this.evaluationName}.xlsx`);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        this.$snotify.error("Hubo un error descargando el reporte.", "Error");
      }
      this.isDownloadingReport = false;
    },

    async eventdialog(data, parameters) {
      this.rangeDialogActive = false;
      if (data !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await this.axiosInstance.post(
            `/quality/export/evaluation/detaill/${this.id}`,
            parameters
          );
          // console.log("DATA CUSTOM", data)
          this.overviewItems = data;
          this.customParameters = parameters;
          this.customSearchInfo = parameters;
        } catch (err) {
          console.log(err);
        }
        this.isLoading = false;
      } else {
        this.tab = 0;
        this.getCallsInfo(0);
      }
      return;
    },
  }
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
}
</style>
